import { CellProps } from 'react-table'
import { ExameActionsCell } from './ExameActionsCell'
import { ExameAsoView } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  TableColumn,
} from '../../../../../../components'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** LocalDateTime do backend → "dd/mm/aaaa hh:mm"; ausente vira o traço do StackedCell. */
const dataHora = (date?: string) => (date ? formatDateTime(date) : undefined)

export const ExameColumns = (t: TFunction): ReadonlyArray<TableColumn<ExameAsoView>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<ExameAsoView>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${row.original.exame ?? 'exame'}`}
      />
    ),
  },
  sortableColumn<ExameAsoView>({
    id: 'exame',
    useQueryRequest,
    fields: [{ field: 'exame', label: 'Exame' }],
    Cell: ({ row }: CellProps<ExameAsoView>) => <StackedCell primary={row.original.exame} />,
  }),
  // Onde o exame se aplica: setor e cargo, cada um ordenável.
  sortableColumn<ExameAsoView>({
    id: 'setor.nome',
    cellWidth: '260px',
    useQueryRequest,
    fields: [
      { field: 'setor.nome', label: 'Setor' },
      { field: 'cargo.nome', label: 'Cargo' },
    ],
    Cell: ({ row }: CellProps<ExameAsoView>) => (
      <StackedCell primary={row.original.setor?.nome} secondary={row.original.cargo?.nome} />
    ),
  }),
  // Última edição em destaque; criação como linha de apoio.
  {
    Header: () => (
      <PlainHeader>
        {t('cols.data.edicao')} / {t('cols.data.criacao')}
      </PlainHeader>
    ),
    id: 'dataAlteracao',
    cellWidth: '188px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<ExameAsoView>) => (
      <StackedCell
        tabular
        primary={dataHora(row.original.dataAlteracao)}
        secondary={dataHora(row.original.dataInclusao)}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<ExameAsoView>) => <ExameActionsCell exame={row.original} />,
  },
]
